(function () {
    'use strict';
    var controllerId = 'commercialeAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', 'societa', commercialeAdd]);

    function commercialeAdd($scope, $uibModalInstance, datacontext, common) {
        $scope.commerciale = {};        
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        $scope.fBStato = 1;

        $scope.ok = function (isValid) {            
            if (isValid) {

                if ($scope.fBStato == 1)
                    $scope.commerciale.Interno = true;
                if ($scope.fBStato == 2)
                    $scope.commerciale.Interno = false;

        	    addItem($scope.commerciale).then(function (result) {
        	        if (result == '502') logError('Username gi&agrave; registrata');
        	        else if (!result || result.Id == null || result.Id == 0) $uibModalInstance.close(null);
        	        else $uibModalInstance.close(result);
        	    });
        	}
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.suggest = function () {
            if (!$scope.commerciale.Nome || !$scope.commerciale.Cognome)
                return;

            datacontext.user_suggestUserame($scope.commerciale.Nome, $scope.commerciale.Cognome).then(function (username) {
                if (!username || username.trim().length == 0)
                    return;

                $scope.commerciale.Username = username;

                datacontext.user_suggestPassword($scope.commerciale.Nome).then(function (password) {
                    if (!password || password.trim().length == 0)
                        return;

                    $scope.commerciale.Password = password;
                });
            });
        };

        function addItem(item) {
            return datacontext.commerciale_add(item).then(function (data) {        	    
        		return data;
        	});
        }
    }
})();